export const services = [
  {
    id: 1,
    title: "Wedding Photography - 6 Hours",
    price: "$1,200",
    description: "Perfect for intimate ceremonies and smaller celebrations",
    deliveryEstimate: "6–8 weeks",
    features: [
      "6 hours of wedding day coverage",
      "Online album of photos",
      "Professional editing",
      "Second shooter available (+$600)"
    ]
  },
  {
    id: 2, 
    title: "Wedding Photography - 8 Hours",
    price: "$1,500",
    description: "Most popular package for full wedding day coverage",
    deliveryEstimate: "6–8 weeks",
    features: [
      "8 hours of wedding day coverage",
      "Online album of photos",
      "Five free professionally printed photos (max 8x10)",
      "Professional editing",
      "Second shooter available (+$750)"
    ]
  },
  {
    id: 3,
    title: "Wedding Photography - 10 Hours", 
    price: "$1,800",
    description: "Complete coverage from preparation to reception",
    deliveryEstimate: "6–8 weeks",
    features: [
      "10 hours of wedding day coverage",
      "Online album of photos", 
      "Ten free professionally printed photos (max 11x14)",
      "Professional editing",
      "Second shooter available (+$900)"
    ]
  },
  {
    id: 4,
    title: "Portrait Sessions",
    price: "$300", 
    description: "Beautiful portraits without equine",
    deliveryEstimate: "7–10 days",
    features: [
      "One hour shooting session",
      "One outfit change",
      "One location",
      "Online album of digital photos"
    ]
  },
  {
    id: 5,
    title: "Equine Lifestyle Portraits",
    price: "$375",
    description: "Capturing the bond between horse and rider",
    deliveryEstimate: "7–10 days",
    features: [
      "One hour shooting session",
      "One outfit change (two outfits total)",
      "One location", 
      "Online album of at least 30 digital photos"
    ]
  },
  {
    id: 6,
    title: "Barn Group Sessions",
    price: "$180 per horse/rider",
    description: "Special pricing for barn groups only",
    deliveryEstimate: "4–6 weeks",
    features: [
      "Up to 30 minutes shooting",
      "One outfit change (two outfits total)",
      "Location on barn property",
      "Online album of at least 15 digital photos"
    ]
  },
  {
    id: 7,
    title: "Black Background Equine",
    price: "$225", 
    description: "Fine art studio-style portraits",
    deliveryEstimate: "2–3 weeks",
    features: [
      "Necessary shooting time",
      "3 edited, digital, fine art photos",
      "Print release included"
    ]
  }
];

// Additional info for travel fees
export const additionalInfo = {
  travel: "Travel mileage above 50 mile radius: $60"
};